import { Record } from 'immutable';

type Impersonation = {
  activeSession: boolean;
  code: string | null;
  error: string | null;
};

const initialState: Impersonation = {
  activeSession: false,
  code: null,
  error: null,
};

export default class ImpersonationState extends Record(initialState) { }
